import { useEffect, useState } from 'react';
import { getExtractionQueuePauseState } from '../services/api';

/**
 * Poll l'état de pause de la queue d'extraction (PROD1.4.6 hotfix).
 * Retourne `true` si la queue interactive est paused OU si la pause globale RQ
 * est active. Light call (`{paused: bool}`), poll toutes les 30 secondes.
 *
 * Utilisé par DocumentDetailPage et DocumentsPage pour afficher un bandeau
 * informatif à l'analyste.
 */
export function useExtractionQueuePause(intervalMs: number = 30_000): boolean {
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const tick = () => {
      getExtractionQueuePauseState()
        .then((r) => {
          if (!cancelled) setPaused(!!r.paused);
        })
        .catch(() => {
          /* silent */
        });
    };
    tick();
    const id = window.setInterval(tick, intervalMs);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, [intervalMs]);

  return paused;
}
